import type { GeomateTabType } from '@library/model'
import { getDisplayName, VISIBLE_BROWSER_TABS, VISIBLE_CORE_TABS } from '@library/model'

export type ButtonItem = {
  type: GeomateTabType
  label: string
}

export const CORE_TABS_BUTTONS = VISIBLE_CORE_TABS.map<ButtonItem>(type => ({
  type,
  label: getDisplayName(type),
}))

export const BROWSER_TABS_BUTTONS = VISIBLE_BROWSER_TABS.map<ButtonItem>(type => ({
  type,
  label: getDisplayName(type),
}))
